let projectContactLabel = 'Estimating Coordinator';

function initScheduler($el) {
	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL)) {
		projectContactLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL);
	}

	PJQ.app.session.fetchUsers(function (users) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'schedule',
				},
				{
					endpoint: 'eventtypes'
				}
			])
		}).get().done(_.bind(function (eventTypes) {
			PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PANTERASCHEDULE, 'Master', {isOldModule: true}), $el, {
				eventTypes: eventTypes,
				users: users.models,
				filterUserId: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_SCHEDULE_FILTER_USER_ID) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_SCHEDULE_FILTER_USER_ID) : PJQ.app.session.user.id
			}, function () {
				renderScheduler();
			});
		}, this));
	});
}

function renderScheduler() {
	let format = scheduler.date.date_to_str("%Y-%m-%d");
	jQuery('#scheduler_here').parent().css('width', '100%');
	jQuery('#scheduler_here').parent().css('height', '100%');
	jQuery('#scheduler_here').parent().parent().css('width', '100%');
	jQuery('#scheduler_here').parent().parent().css('height', '100%');
	scheduler.templates.tooltip_text = function (start, end, event) {
		if (event.eventName === 'Misc')
			return "<table><tr><td><b>Event:</b></td><td>" + event.eventName + "</td></tr><tr><td><b>Description:</b></td><td>" + event.text + "</td></tr></table>";
		else
			return "<table><tr><td><b>Event:</b></td><td>" + event.eventName + "</td></tr><tr><td><b>Project:</b></td><td><a href='javascript:void(0)' onclick='navToProject(" + event.projectId + ");'>" + event.projectName + "</a></td></tr><tr><td><b>Location:</b></td><td>" + event.projectAddress1 + "<br/>" + event.projectAddress2 + "</td></tr><tr><td><b>City, State, Zip:</b></td><td>" + event.projectCity + ", " + event.projectState + " " + event.projectZip + "</td></tr></table>";

	};
	scheduler.templates.event_header = function (startIsUnionStatusRequired, end, ev) {
		let en = ev.eventName || 'New Event';
		return '<b>' + en + '</b>';
	};
	scheduler.templates.event_text = function (start, end, ev) {
		if ((scheduler.getState().new_event && !ev.id) || ev.eventName == null)
			return ev.eventName || 'New Event';
		else
			return ev.projectName + ' - ' + ev.projectCity + ',' + ev.projectState;
	};
	scheduler.templates.event_bar_text = function (start, end, ev) {
		if ((scheduler.getState().new_event && !ev.id) || ev.eventName == null)
			return ev.eventName || 'New Event';
		else {
			if (ev.eventName === 'Misc')
				return ev.eventName + ' - ' + ev.text;
			else
				return ev.eventName + ' - ' + ev.projectName + ' - ' + ev.projectCity + ', ' + ev.projectState;
		}
	};
	scheduler.templates.event_bar_date = function (start, end, ev) {
		if (null != ev.fieldId && ev.fieldId < 0) {
			let dtemp = new Date(start),
				h = dtemp.getHours(),
				ampm = 'AM';
			if (h > 12) {
				h = h - 12;
				ampm = 'PM';
			}
			else if (h === 12) {
				ampm = 'PM';
			}
			let hr = h.toString();
			if (h === 0)
				hr = '12';
			let min = dtemp.getMinutes().toString();
			if (dtemp.getMinutes() < 10)
				min = '0' + dtemp.getMinutes().toString();
			return hr + ':' + min + ' ' + ampm + ' - ';
		}
		else {
			let dtemp = new Date(start),
				h = dtemp.getHours();
			if (h === 12)
				return '';
			else {
				let ampm = 'AM';
				if (h > 12) {
					h = h - 12;
					ampm = 'PM';
				}
				else if (h === 12) {
					ampm = 'PM';
				}
				let hr = h.toString();
				if (h === 0)
					hr = '12';
				let min = dtemp.getMinutes().toString();
				if (dtemp.getMinutes() < 10)
					min = '0' + dtemp.getMinutes().toString();
				return hr + ':' + min + ' ' + ampm + ' - ';
			}
		}
		//return scheduler.templates.event_date(start)+' ';
	};

	if (PJQ.app.session.hasPermission('calendar.isAdmin')) {
		scheduler.attachEvent("onBeforeDrag", function (event_id, mode, native_event_object) {
			if ('resize' === mode)
				return false;

			let ev = this.getEvent(event_id);
			return !(null != ev && ev.masterUserId !== PJQ.app.session.get('masterUserId'));
		});
	}
	scheduler.attachEvent("onClick", function (event_id, native_event_object) {
		scheduler.showLightbox(event_id);
		return false;
	});
	scheduler.templates.lightbox_header = function (start, end, ev) {
		let en = ev.eventName || 'New Event';
		return '<b>' + en + '</b>';
	};
	scheduler.locale.labels.section_project = "Project Info";
	scheduler.locale.labels.section_evtype = "Event Type";
	scheduler.locale.labels.section_time = "Event Date";

	scheduler.form_blocks["projectInfo"] = {
		render: function (sns) {
			return "<div class='dhx_cal_ltext' style='height:115px;'><table><tr><td><b>Event:</b></td><td><label id='levname'></label></td></tr><tr><td><b>Project:</b></td><td><a id='aprojname'><label id='levprojname'></label></a></td></tr><tr><td><b>Location:</b></td><td><label id='levprojloc'></label></td></tr><tr><td><b>City, State, Zip:</b></td><td><label id='levprojcsz'></label></td></tr><tr><td><b><label id='levprojcontlabel'></label></b></td><td><label id='levprojcont'></label></td></tr></table></div>";
		},
		set_value: function (node, value, ev) {
			jQuery('#levname').text(ev.eventName);
			jQuery('#levprojname').text(ev.projectName || 'N/A');
			if (null != ev.projectId && ev.projectId > 0) {
				let ploc = ev.projectAddress1;
				if ("" !== ev.projectAddress2)
					ploc += '<br />' + ev.projectAddress2;
				jQuery('#levprojloc').html(ploc || '');
				let pcsz = ev.projectCity + ', ' + ev.projectState + ' ' + ev.projectZip;
				jQuery('#levprojcsz').text(pcsz || '');
				jQuery('#levprojcontlabel').text(projectContactLabel + ':');
				jQuery('#levprojcont').html(ev.projectContact + " - <a href='mailto:" + ev.projectContactEmail + "'>" + ev.projectContactEmail + "</a>");
				jQuery('#aprojname').attr('pjq-project-id', ev.projectId);
				jQuery('#aprojname').click(function () {
					let pid = jQuery(this).attr('pjq-project-id');
					__doPostBack("SelectProject", pid);
				});
			}
			else {
				jQuery('#levprojloc').text('');
				jQuery('#levprojcsz').text('');
				jQuery('#aprojname').click(function () {
					alert("This Event is not tied to a Project.  To create a Project-based event, please do so from the Project Wall.");
				});
			}
		},
		get_value: function (node, ev) {
			return jQuery('#levprojname').text();
		},
		focus: function (node) {
		}
	};
	scheduler.form_blocks["time"] = {
		render: function (sns) {
			return "<div class='' style='height:30px;text-align: left;padding-left: 10px;'><input id='ev_start' name='ev_start' type='text' class='datepick' style='width: 100px;' />&nbsp;<span id='sevtime' style='display:none;'><select id='ev_time' name='ev_time'><option value='12:00 AM'>12:00 AM</option><option value='01:00 AM'>01:00 AM</option><option value='02:00 AM'>02:00 AM</option><option value='03:00 AM'>03:00 AM</option><option value='04:00 AM'>04:00 AM</option><option value='05:00 AM'>05:00 AM</option><option value='06:00 AM'>06:00 AM</option><option value='07:00 AM'>07:00 AM</option><option value='08:00 AM'>08:00 AM</option><option value='09:00 AM'>09:00 AM</option><option value='10:00 AM'>10:00 AM</option><option value='11:00 AM'>11:00 AM</option><option value='12:00 PM'>12:00 PM</option><option value='01:00 PM'>01:00 PM</option><option value='02:00 PM'>02:00 PM</option><option value='03:00 PM'>03:00 PM</option><option value='04:00 PM'>04:00 PM</option><option value='05:00 PM'>05:00 PM</option><option value='06:00 PM'>06:00 PM</option><option value='07:00 PM'>07:00 PM</option><option value='08:00 PM'>08:00 PM</option><option value='09:00 PM'>09:00 PM</option><option value='10:00 PM'>10:00 PM</option><option value='11:00 PM'>11:00 PM</option></select></span></div>";
		},
		set_value: function (node, value, ev) {
			let ds = new Date(ev.start_date),
				tim = '12:00 AM';
			if (ds.getHours() > 0 && ds.getHours() < 10)
				tim = '0' + ds.getHours().toString() + ':00 AM';
			else if (ds.getHours() > 9 && ds.getHours() < 13)
				tim = ds.getHours().toString() + ':00 AM';
			else if (ds.getHours() > 12 && ds.getHours() < 22)
				tim = '0' + (ds.getHours() - 12).toString() + ':00 PM';
			else
				tim = (ds.getHours() - 12).toString() + ':00 PM';

			jQuery('#ev_start').val(jQuery.datepicker.formatDate('mm/dd/yy', ev.start_date));
			if (null != ev.fieldId && ev.fieldId < 0) {
				jQuery('#sevtime').css('display', '');
				jQuery('#ev_time').val(tim);
			}
			else {
				jQuery('#sevtime').css('display', 'none');
				jQuery('#ev_time').val('');
			}

			if (ev.masterUserId !== PJQ.app.session.get('masterUserId')) {
				jQuery('#ev_start').attr('disabled', 'disabled');
				jQuery('#ev_time').attr('disabled', 'disabled');
			}
			else {
				jQuery('#ev_start').removeAttr('disabled');
				jQuery('#ev_time').removeAttr('disabled');
			}
		},
		get_value: function (node, ev) {
			let tim = ' 12:00 AM',
				evtim = jQuery('#ev_time').val();
			if (evtim !== '')
				tim = ' ' + jQuery('#ev_time').val();

			let dt = new Date(jQuery('#ev_start').val() + tim),
				ds = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds()),
				de = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());
			if (evtim !== '')
				de.setHours(ds.getHours() + 1);
			else
				de.setDate(ds.getDate() + 1);
			ev.start_date = ds;
			ev.end_date = de;
			return jQuery.datepicker.formatDate('yy-mm-dd', ds);
		},
		focus: function (node) {
		}
	};

	scheduler.config.lightbox.sections = [
		{name: "project", height: 70, map_to: "projectName", type: "projectInfo", focus: false},
		{name: "description", height: 50, map_to: "text", type: "textarea", focus: true},
		{name: "time", height: 72, type: "time", map_to: "ev_start"}
	];
	scheduler.config.readonly = !PJQ.app.session.hasPermission('calendar.isAdmin');

	scheduler.attachEvent("onLightbox", function (event_id) {
		jQuery('#ev_start').datepicker({
			numberOfMonths: 3,
			showButtonPanel: true,
			buttonImage: "/i/calendar.png",
			buttonImageOnly: true
		});
		if (null != jQuery('.dhx_multi_day'))
			reSizeCal();
		return true;
	});

	scheduler.attachEvent("onEventCreated", function (event_id, event_object) {
		let ev = this.getEvent(event_id);
		ev.eventName = 'Misc';
		ev.scheduleId = 0;
		ev.masterUserId = PJQ.app.session.get('masterUserId');
		ev.fieldId = -2;
		return true;
	});

	scheduler.attachEvent("onBeforeLightbox", function (id) {
		let ev = this.getEvent(id);
		//scheduler.config.buttons_right = (scheduler.getState().new_event || ev.eventName != 'Misc') ? [] : ["dhx_delete_btn"];
		scheduler.resetLightbox();
		return true;
	});

	scheduler.config.hour_date = "%h:%i %A";
	scheduler.config.details_on_create = true;
	scheduler.config.details_on_dblclick = true;
	scheduler.config.time_step = 60;
	scheduler.config.show_loading = true;
	scheduler.config.auto_end_date = true;
	scheduler.config.event_duration = 60;
	scheduler.config.first_hour = 0;
	scheduler.config.last_hour = 24;
	scheduler.config.start_on_monday = true;
	scheduler.config.multi_day = true;
	scheduler.config.xml_date = "%Y-%m-%d %H:%i";
	dhtmlXTooltip.config.delta_x = -5;
	dhtmlXTooltip.config.delta_y = -5;
	dhtmlXTooltip.config.timeout_to_hide = 2000;
	scheduler.xy.bar_height = 44;

	scheduler.attachEvent("onViewChange", function (mode, date) {
		if ((mode === 'day' || mode === 'week') && null != jQuery('.dhx_multi_day')) {
			reSizeCal();
		}
		return true;
	});

	scheduler.attachEvent("onAfterSchedulerResize", function () {
		reSizeCal();
		return true;
	});
	scheduler.attachEvent("onAfterLightbox", function () {
		reSizeCal();
		return true;
	});
	scheduler.attachEvent("onEventDeleted", function () {
		reSizeCal();
		return true;
	});
	scheduler.attachEvent("onEventSave", function () {
		reSizeCal();
		return true;
	});
	scheduler.attachEvent("onEventCancel", function () {
		reSizeCal();
		return true;
	});

	scheduler.filter_day = scheduler.filter_week = scheduler.filter_month = scheduler.filter_timeline = function (ev_id, event) {
		let selUserId = jQuery('#SelUser').val(),
			selEventId = jQuery('#SelEvent').val();
		if (selUserId !== '' && selUserId !== event.userId && selUserId !== event.user2Id)
			return false;
		else if (selEventId !== '' && selEventId !== event.eventName)
			return false;
		return true;
	};
	scheduler.init("scheduler_here", new Date(), "month");
	scheduler.setLoadMode("month");
	scheduler.config.prevent_cache = true;
	scheduler.clearAll();
	scheduler.load("/DesktopModules/PanteraSchedule/GetProjSched.aspx?sid=" + PJQ.app.session.id + "&guid=" + PJQ.helpers.guid());
	let dp = new dataProcessor("/DesktopModules/PanteraSchedule/UpdProjSched.aspx?sid=" + PJQ.app.session.id);
	dp.init(scheduler);

	jQuery.validator.addMethod("datePT", function (value, element) {
		let c = !1, d = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
		if (d.test(value)) {
			let e = value.split("/"), f = parseInt(e[0], 10), g = parseInt(e[1], 10), h = parseInt(e[2], 10),
				i = new Date(h, f - 1, g);
			i.getFullYear() === h && i.getMonth() === f - 1 && i.getDate() === g ? c = !0 : c = !1
		}
		else
			c = !1;
		return this.optional(element) || c;
	}, "Please enter a valid date.");

}

function reSizeCal() {
	if (null == jQuery('.dhx_multi_day'))
		return;
	let ht = jQuery('.dhx_multi_day').height(),
		wd = jQuery('.dhx_multi_day').width();
	if (ht > 180) {
		jQuery('.dhx_multi_day').css('height', '180px');
		let ot = jQuery('#scheduler_here').offset().top + 120,
			ol = jQuery('#scheduler_here').offset().left + 10;
		jQuery('.dhx_multi_day_icon').css('background-position', ol.toString() + 'px ' + ot.toString() + 'px');
		jQuery('.dhx_multi_day_icon').css('background-attachment', 'fixed');
		jQuery('.dhx_multi_day_icon').css('background-repeat', 'no-repeat');
		jQuery('.dhx_multi_day').css('width', wd.toString() + 'px');
		jQuery('.dhx_multi_day').css('overflow', 'auto');

		let ht2 = jQuery('.dhx_cal_data').height() + (ht - 180);
		jQuery('.dhx_cal_data').css('height', ht2.toString() + 'px');
		jQuery('.dhx_cal_data').css('top', '224px');
	}
}

function saveics() {
	new PJQ.ajax.Request({
		endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'schedule'
			},
			{
				endpoint: 'exportold'
			}
		]),
		data: {
			exportData: scheduler.toICal(),
			fileExtension: 'ics'
		}
	}).post().success(_.bind(function (data) {
		PJQ.files.downloadFile(data.url, { isEndpoint: false });
	}, this));
	//PanteraScript.PanteraScriptService.SaveExport(scheduler.toICal(), 'ics', calexpdone, onScriptError);
}

function savepdf() {
	let result = scheduler.toPDF('/DesktopModules/PanteraSchedule/CalExport.aspx');
	new PJQ.ajax.Request({
		endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'schedule'
			},
			{
				endpoint: 'exportold'
			}
		]),
		data: {
			exportData: result,
			fileExtension: 'pdf'
		}
	}).post().success(_.bind(function (data) {
		PJQ.files.downloadFile(data.url, { isEndpoint: false });
	}, this));
	//PanteraScript.PanteraScriptService.SaveExport(result, 'pdf', calexpdone, onScriptError);
}

function calexpdone(response) {
	//jQuery('#DownloadFrame2').attr('src', response);

	jQuery("#dl_export").attr('href', response);
	jQuery("#dlg-export").dialog({
		resizable: false,
		height: 230,
		modal: true,
		buttons: {
			"Close": function () {
				jQuery(this).dialog("close");
			}
		}
	});
}

function navToProject(projectId) {
	$('.dhtmlXTooltip').remove();
	PJQ.app.router.navigate('projects/' + projectId, {
		trigger: true
	});
}